// filters
$.expr[':'].external = function(obj) {
    'use strict';
    try {
        if (obj.href) {
            return !obj.href.match(/^mailto:/) && (obj.hostname != location.hostname);
        }
        return false;
    } catch (e) {
        return false;
    }
};
$.expr[':'].download = function(obj) {
    'use strict';
    try {
        if (obj.href) {
            return (obj.href.match(/\.(pdf|doc|docx|xls||xlsx|cvx|jpg|gif|mp3|swf|txt|ppt|zip|gz|dmg)$/) !== null);
        }
        return false;
    } catch (e) {
        return false;
    }
};
$.expr[':'].image = function(obj) {
    'use strict';
    try {
        if (obj.href) {
            return (obj.href.match(/\.(jpg|png|jpeg|JPG|PNG)$/) !== null);
        }
        return false;
    } catch (e) {
        return false;
    }
};

$(document).ready(function() {
    'use strict';
    // enllaços externs en finestra nova
    $('a:external, a[rel=external]').attr('target', '_blank').addClass('external').attr('rel', 'external');
    $('a:download, a[rel=document]').attr('target', '_blank').addClass('document').attr('rel', 'document');

    // enllaç al pare (per iframes, etc..)
    $('a[rel=parent]').attr('target', '_parent');

    // evitem spam als correus
    $("a[href*='(ELIMINAR)']").each(function() {
        var t = $(this);
        var omg = t.attr('href');
        var omg2 = t.text();
        t.attr('href', omg.replace('(ELIMINAR)', ''));
        t.text(omg2.replace('(ELIMINAR)', ''));
    });

    // protecció antispam
    $('input[name="houdiniControl"]').remove();

    // identifiquem el primer i l'últim element de les llistes
    $('ul, ol').each(function() {
        var t = $(this);
        t.children('li:first').addClass('first');
        t.children('li:last').addClass('last');
    });

    // popups
    $('.popup').magnificPopup({
        type: 'image'
    });

    $('.gallery-item').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true,
            tCounter: '<span class="mfp-counter">%curr% de %total%</span>' // markup of counter
        }
    });

    // $('a[href*="youtube.com"]').attr('class', 'popup-youtube');

    $('.popup-youtube').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        iframe: {
            patterns: {
                youtube: {
                    index: 'youtube.com/',
                    id: 'v=',
                    src: '//www.youtube-nocookie.com/embed/%id%?autoplay=1&rel=0'
                }
            }
        },
        callbacks: {
            markupParse: function(template, values, item) {
                if (item.el.hasClass('short')) {
                    template.addClass('short');
                }
            }
        }
    });

    $('.popup-instagram').magnificPopup({
        type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false

    });


    $('.protecciodades a').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
    });


    if($('.infinite-paginator-button-wrapper').length) {
        $(document).on('click', '.infinite-paginator-button-wrapper a', function(e){


            $(this).parent().remove();

            var listURL = $(this).attr('href');
            $.ajax(
            {
                url : listURL,
                type: "GET",
                success:function(data, textStatus, jqXHR)
                {
                    $(this).parent().remove();
                },
                error: function(jqXHR, textStatus, errorThrown)
                {

                }
            });
            e.preventDefault(); //STOP default action
        });
    }

function getYouTubeId(url) {
  try {
    var cleanUrl = url.trim();

    // Si no hi ha protocol, afegim https://
    if (!/^https?:\/\//i.test(cleanUrl)) {
      cleanUrl = 'https://' + cleanUrl;
    }

    var u = document.createElement('a');
    u.href = cleanUrl;

    var h = u.hostname.replace(/^www\./, "");
    if (h === "youtu.be") return u.pathname.slice(1);
    if (h.indexOf("youtube.com") > -1) {
      if (u.pathname === "/watch") {
        var params = (u.search || '').replace(/^\?/, '').split('&');
        for (var i = 0; i < params.length; i++) {
          var pair = params[i].split('=');
          if (pair[0] === 'v') return pair[1];
        }
      }
      if (u.pathname.indexOf("/shorts/") === 0) return u.pathname.split("/")[2] || u.pathname.split("/")[1];
      if (u.pathname.indexOf("/embed/") === 0) return u.pathname.split("/")[2];
    }
  } catch (e) {}
  return null;
}



$('p.iframe-youtube, p.youtube').each(function () {
    var url = $(this).text().trim();
    var id = getYouTubeId(url);
    if (!id) return;

    // Paràmetres bàsics d’embed
    var embedSrc = "https://www.youtube.com/embed/" + id + "?rel=0&modestbranding=1&playsinline=1";

    // Comprova si hi ha temps d'inici
    var startMatch = url.match(/[?&](?:start|t)=(\d+)/);
    if (startMatch) {
      embedSrc += "&start=" + parseInt(startMatch[1], 10);
    }

    // Wrapper responsive
    var $wrapper = $('<div/>', { class: 'yt-wrapper' }).css({
      position: 'relative',
      width: '100%',
      paddingTop: '56.25%',
      overflow: 'hidden',
      borderRadius: '0',
      marginBottom: '1.5em'
    });

    var $iframe = $('<iframe/>', {
      src: embedSrc,
      title: 'YouTube video player',
      allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
      allowfullscreen: true
    }).css({
      position: 'absolute',
      top: 0, left: 0, width: '100%', height: '100%', border: 0
    });

    $wrapper.append($iframe);
    $(this).replaceWith($wrapper);
  });
});


 function getInstagramReelId(url) {
    try {
      var cleanUrl = url.trim();

      // Si no té protocol, afegim https://
      if (!/^https?:\/\//i.test(cleanUrl)) {
        cleanUrl = 'https://' + cleanUrl;
      }

      var a = document.createElement('a');
      a.href = cleanUrl;

      // Exemple de path: /reel/C2K7WxzN7tK/
      var parts = a.pathname.split('/');
      for (var i = 0; i < parts.length; i++) {
        if (parts[i] === 'reel' && parts[i + 1]) {
          return parts[i + 1];
        }
      }
    } catch (e) {}
    return null;
  }
  // --- Processar Instagram ---
  $('p.instagram').each(function () {
    var url = $(this).text();
    var id = getInstagramReelId(url);
    if (!id) return;

    var $iframe = $('<iframe/>', {
      src: "https://www.instagram.com/reel/" + id + "/embed",
      frameborder: 0,
      scrolling: "no",
      allowtransparency: "true",
      allowfullscreen: "true"
    });

    var $wrapper = $('<div/>', { class: 'ig-embed' });
    $wrapper.append($iframe);
    $(this).replaceWith($wrapper);
  });
